// Admin.js - dengan dukungan import bad_words (fixed)
import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import API_BASE_URL from "./config/api";
import "./admin.css";

function Admin() {
  const [activeTab, setActiveTab] = useState("training");
  const [categories, setCategories] = useState([]);
  const [intents, setIntents] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [logs, setLogs] = useState([]);
  const [badWords, setBadWords] = useState([]);
  const [expandedCats, setExpandedCats] = useState({});
  const [expandedIntents, setExpandedIntents] = useState({});
  const [modal, setModal] = useState({ open: false, type: null, mode: null, data: null });
  const [formCat, setFormCat] = useState({ name: "" });
  const [formIntent, setFormIntent] = useState({ category_id: "", name: "", response: "", emotion: "neutral" });
  const [formQuestion, setFormQuestion] = useState({ intent_id: "", question: "" });
  const [formBadWord, setFormBadWord] = useState({ word: "" });
  
  const [importing, setImporting] = useState(false);
  const [importProgress, setImportProgress] = useState("");

  const showNotification = (message, isError = false) => {
    alert(`${isError ? "❌ Gagal: " : "✅ Berhasil: "}${message}`);
  };

  const grouped = categories.map((cat) => ({
    category: cat,
    intents: intents.filter(i => i.category_id === cat.id).map(intent => ({
      ...intent,
      questions: questions.filter(q => q.intent_id === intent.id),
    })),
  }));

  const fetchAll = useCallback(async () => {
    try {
      const [l, c, i, q, bw] = await Promise.all([
        axios.get(`${API_BASE_URL}/admin/logs`),
        axios.get(`${API_BASE_URL}/admin/categories`),
        axios.get(`${API_BASE_URL}/admin/intents`),
        axios.get(`${API_BASE_URL}/admin/questions`),
        axios.get(`${API_BASE_URL}/admin/bad-words`),
      ]);
      setLogs(l.data);
      setCategories(c.data);
      setIntents(i.data);
      setQuestions(q.data);
      setBadWords(bw.data);
    } catch (err) {
      console.error(err);
      showNotification("Gagal mengambil data", true);
    }
  }, []);

  useEffect(() => { fetchAll(); }, [fetchAll]);

  // ========== CATEGORY CRUD ==========
  const addCategory = async (name) => {
    if (!name.trim()) return showNotification("Nama kategori kosong", true);
    try { await axios.post(`${API_BASE_URL}/admin/categories`, { name }); showNotification("Kategori ditambahkan"); fetchAll(); } catch (err) { showNotification(err.response?.data?.error || err.message, true); }
  };
  const updateCategory = async (id, name) => {
    if (!name.trim()) return showNotification("Nama kategori kosong", true);
    try { await axios.put(`${API_BASE_URL}/admin/categories/${id}`, { name }); showNotification("Kategori diperbarui"); fetchAll(); } catch (err) { showNotification(err.response?.data?.error || err.message, true); }
  };
  const deleteCategory = async (id) => {
    const cat = categories.find(c => c.id === id);
    if (cat?.question_count > 0) return showNotification("Category masih memiliki questions, hapus dulu.", true);
    if (!window.confirm("Hapus kategori ini?")) return;
    try { await axios.delete(`${API_BASE_URL}/admin/categories/${id}`); showNotification("Kategori dihapus"); fetchAll(); } catch (err) { showNotification(err.response?.data?.error || err.message, true); }
  };

  // ========== INTENT CRUD ==========
  const addIntent = async (intent) => {
    if (!intent.name.trim()) return showNotification("Nama intent kosong", true);
    if (!intent.category_id) return showNotification("Pilih kategori", true);
    try { await axios.post(`${API_BASE_URL}/admin/intents`, intent); showNotification("Intent ditambahkan"); fetchAll(); } catch (err) { showNotification(err.response?.data?.error || err.message, true); }
  };
  const updateIntent = async (id, updates) => {
    if (!updates.name?.trim()) return showNotification("Nama intent kosong", true);
    try { await axios.put(`${API_BASE_URL}/admin/intents/${id}`, updates); showNotification("Intent diperbarui"); fetchAll(); } catch (err) { showNotification(err.response?.data?.error || err.message, true); }
  };
  const deleteIntent = async (id) => {
    const intent = intents.find(i => i.id === id);
    if (intent?.question_count > 0) return showNotification("Intent masih memiliki questions, hapus dulu.", true);
    if (!window.confirm("Hapus intent ini?")) return;
    try { await axios.delete(`${API_BASE_URL}/admin/intents/${id}`); showNotification("Intent dihapus"); fetchAll(); } catch (err) { showNotification(err.response?.data?.error || err.message, true); }
  };

  // ========== QUESTION CRUD ==========
  const addQuestion = async (q) => {
    if (!q.question.trim()) return showNotification("Pertanyaan kosong", true);
    if (!q.intent_id) return showNotification("Pilih intent", true);
    try { await axios.post(`${API_BASE_URL}/admin/questions`, q); showNotification("Pertanyaan ditambahkan"); fetchAll(); } catch (err) { showNotification(err.response?.data?.error || err.message, true); }
  };
  const updateQuestion = async (id, intent_id, question) => {
    if (!question.trim()) return showNotification("Pertanyaan kosong", true);
    if (!intent_id) return showNotification("Intent tidak boleh kosong", true);
    try {
      await axios.put(`${API_BASE_URL}/admin/questions/${id}`, { question, intent_id });
      showNotification("Pertanyaan diperbarui");
      fetchAll();
    } catch (err) {
      showNotification(err.response?.data?.error || err.message, true);
    }
  };
  const deleteQuestion = async (id) => {
    if (!window.confirm("Hapus pertanyaan ini?")) return;
    try { await axios.delete(`${API_BASE_URL}/admin/questions/${id}`); showNotification("Pertanyaan dihapus"); fetchAll(); } catch (err) { showNotification(err.response?.data?.error || err.message, true); }
  };

  // ========== LOGS ==========
  const validate = async (id, status) => {
    try { await axios.post(`${API_BASE_URL}/admin/validate`, { id, is_correct: status }); showNotification(`Log ${status === 1 ? "benar" : "salah"} divalidasi`); fetchAll(); } catch (err) { showNotification(`Gagal validasi: ${err.response?.data?.error || err.message}`, true); }
  };
  const updateLogIntent = async (logId, intentId) => {
    const finalId = intentId === "" ? null : Number(intentId);
    try { await axios.post(`${API_BASE_URL}/admin/update-log-intent`, { log_id: logId, intent_id: finalId }); showNotification("Intent log diubah"); fetchAll(); } catch (err) { showNotification(`Gagal: ${err.response?.data?.error || err.message}`, true); }
  };
  const addFromLog = async (logId) => {
    try { await axios.post(`${API_BASE_URL}/admin/add-from-log`, { log_id: logId }); showNotification("Pertanyaan ditambahkan ke intent"); fetchAll(); } catch (err) { showNotification(`Gagal: ${err.response?.data?.error || err.message}`, true); }
  };

  // ========== BAD WORDS CRUD ==========
  const addBadWord = async (word) => {
    if (!word.trim()) return showNotification("Kata tidak boleh kosong", true);
    try {
      await axios.post(`${API_BASE_URL}/admin/bad-words`, { word });
      showNotification("Kata kotor ditambahkan");
      fetchAll();
    } catch (err) {
      showNotification(err.response?.data?.error || err.message, true);
    }
  };
  const updateBadWord = async (id, word) => {
    if (!word.trim()) return showNotification("Kata tidak boleh kosong", true);
    try {
      await axios.put(`${API_BASE_URL}/admin/bad-words/${id}`, { word });
      showNotification("Kata kotor diperbarui");
      fetchAll();
    } catch (err) {
      showNotification(err.response?.data?.error || err.message, true);
    }
  };
  const deleteBadWord = async (id) => {
    if (!window.confirm("Hapus kata kotor ini?")) return;
    try {
      await axios.delete(`${API_BASE_URL}/admin/bad-words/${id}`);
      showNotification("Kata kotor dihapus");
      fetchAll();
    } catch (err) {
      showNotification(err.response?.data?.error || err.message, true);
    }
  };

  // ========== EXPORT EXCEL ==========
  const exportExcel = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/admin/export-json`);
      const { categories, intents, questions, chat_logs, bad_words } = response.data;
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(categories), "categories");
      XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(intents), "intents");
      XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(questions), "questions");
      XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(chat_logs), "chat_logs");
      XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(bad_words), "bad_words");
      XLSX.writeFile(wb, "chatbot.xlsx");
      showNotification("Ekspor berhasil");
    } catch (err) {
      console.error(err);
      showNotification("Gagal mengekspor data", true);
    }
  };

  // ========== IMPORT EXCEL ==========
  const cleanExcelData = (data, type) => {
    return data.map(row => {
      const cleaned = { ...row };
      if (type === 'categories') {
        if (cleaned.id !== undefined) cleaned.id = Number(cleaned.id) || undefined;
        if (cleaned.name) cleaned.name = String(cleaned.name).trim();
      }
      if (type === 'intents') {
        if (cleaned.id !== undefined) cleaned.id = Number(cleaned.id) || undefined;
        if (cleaned.category_id !== undefined && cleaned.category_id !== '') cleaned.category_id = Number(cleaned.category_id) || null;
        else cleaned.category_id = null;
        if (cleaned.name) cleaned.name = String(cleaned.name).trim();
        if (cleaned.response) cleaned.response = String(cleaned.response).trim();
        if (cleaned.emotion) cleaned.emotion = String(cleaned.emotion).trim();
        if (!cleaned.emotion) cleaned.emotion = "neutral";
      }
      if (type === 'questions') {
        if (cleaned.id !== undefined) cleaned.id = Number(cleaned.id) || undefined;
        if (cleaned.intent_id !== undefined && cleaned.intent_id !== '') cleaned.intent_id = Number(cleaned.intent_id) || null;
        else cleaned.intent_id = null;
        if (cleaned.question) cleaned.question = String(cleaned.question).trim();
      }
      // PERBAIKAN: bad_words - mapping kolom 'words' ke 'word' jika ada
      if (type === 'bad_words') {
        // Jika kolom menggunakan 'words' (bukan 'word'), pindahkan ke 'word'
        if (cleaned.words !== undefined && cleaned.word === undefined) {
          cleaned.word = cleaned.words;
          delete cleaned.words;
        }
        if (cleaned.id !== undefined) cleaned.id = Number(cleaned.id) || undefined;
        if (cleaned.word) cleaned.word = String(cleaned.word).trim().toLowerCase();
        // Hapus properti kosong
        delete cleaned['__EMPTY'];
      }
      return cleaned;
    });
  };

  const importExcel = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const fileExt = file.name.split(".").pop().toLowerCase();
    if (fileExt !== "xlsx") {
      showNotification("Hanya file .xlsx yang diperbolehkan", true);
      e.target.value = "";
      return;
    }
    if (file.size > 2 * 1024 * 1024) {
      showNotification("Ukuran file maksimal 2MB", true);
      e.target.value = "";
      return;
    }

    setImporting(true);
    setImportProgress("Membaca file...");

    const reader = new FileReader();
    reader.onload = async (evt) => {
      try {
        const data = new Uint8Array(evt.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        
        setImportProgress("Memproses sheet categories...");
        const categoriesSheet = workbook.Sheets["categories"];
        let categories = categoriesSheet ? XLSX.utils.sheet_to_json(categoriesSheet) : [];
        categories = cleanExcelData(categories, 'categories');
        
        setImportProgress("Memproses sheet intents...");
        const intentsSheet = workbook.Sheets["intents"];
        let intents = intentsSheet ? XLSX.utils.sheet_to_json(intentsSheet) : [];
        intents = cleanExcelData(intents, 'intents');
        
        setImportProgress("Memproses sheet questions...");
        const questionsSheet = workbook.Sheets["questions"];
        let questions = questionsSheet ? XLSX.utils.sheet_to_json(questionsSheet) : [];
        questions = cleanExcelData(questions, 'questions');
        
        // BACA SHEET bad_words
        setImportProgress("Memproses sheet bad_words...");
        const badWordsSheet = workbook.Sheets["bad_words"];
        let bad_words = badWordsSheet ? XLSX.utils.sheet_to_json(badWordsSheet) : [];
        bad_words = cleanExcelData(bad_words, 'bad_words');
        
        // Pastikan setiap bad_word memiliki id (number) - jika tidak ada, gunakan auto-increment dengan ID negatif sementara
        // Tapi backend mewajibkan id, jadi kita harus beri id. Gunakan ID negatif agar tidak bentrok dengan auto-increment.
        let nextId = -1;
        bad_words = bad_words.map(bw => {
          if (!bw.id || isNaN(bw.id)) {
            bw.id = nextId--;
          }
          return bw;
        });
        
        // Validasi: minimal satu sheet memiliki data
        if (categories.length === 0 && intents.length === 0 && questions.length === 0 && bad_words.length === 0) {
          throw new Error("File tidak mengandung sheet 'categories', 'intents', 'questions', atau 'bad_words' yang valid.");
        }
        
        setImportProgress("Mengirim data ke server...");
        const response = await axios.post(`${API_BASE_URL}/admin/import-json`, {
          categories,
          intents,
          questions,
          bad_words
        });
        
        if (response.data.success) {
          const stats = response.data.stats;
          showNotification(`Import berhasil! ${stats.categories} kategori, ${stats.intents} intent, ${stats.questions} pertanyaan, ${stats.bad_words || 0} kata kotor diimpor.`);
          fetchAll();
        } else {
          throw new Error(response.data.error || "Gagal import");
        }
      } catch (err) {
        console.error(err);
        showNotification(err.message || "Gagal mengimpor file", true);
      } finally {
        setImporting(false);
        setImportProgress("");
        e.target.value = "";
      }
    };
    reader.onerror = () => {
      showNotification("Gagal membaca file", true);
      setImporting(false);
      setImportProgress("");
      e.target.value = "";
    };
    reader.readAsArrayBuffer(file);
  };

  // ========== MODAL HANDLERS ==========
  const openAddCategory = () => { setFormCat({ name: "" }); setModal({ open: true, type: "category", mode: "add", data: null }); };
  const openEditCategory = (cat) => { setFormCat({ name: cat.name }); setModal({ open: true, type: "category", mode: "edit", data: cat }); };
  const openAddIntent = (categoryId = "") => { setFormIntent({ category_id: categoryId, name: "", response: "", emotion: "neutral" }); setModal({ open: true, type: "intent", mode: "add", data: null }); };
  const openEditIntent = (intent) => { setFormIntent({ category_id: intent.category_id, name: intent.name, response: intent.response, emotion: intent.emotion || "neutral" }); setModal({ open: true, type: "intent", mode: "edit", data: intent }); };
  const openAddQuestion = (intentId = "") => { setFormQuestion({ intent_id: intentId, question: "" }); setModal({ open: true, type: "question", mode: "add", data: null }); };
  const openEditQuestion = (question) => { 
    setFormQuestion({ 
      intent_id: question.intent_id, 
      question: question.question 
    }); 
    setModal({ open: true, type: "question", mode: "edit", data: question }); 
  };
  const openAddBadWord = () => { setFormBadWord({ word: "" }); setModal({ open: true, type: "badword", mode: "add", data: null }); };
  const openEditBadWord = (badWord) => { setFormBadWord({ word: badWord.word }); setModal({ open: true, type: "badword", mode: "edit", data: badWord }); };

  const handleModalSubmit = () => {
    if (modal.type === "category") {
      if (modal.mode === "add") addCategory(formCat.name);
      else updateCategory(modal.data.id, formCat.name);
    } else if (modal.type === "intent") {
      if (modal.mode === "add") addIntent(formIntent);
      else updateIntent(modal.data.id, formIntent);
    } else if (modal.type === "question") {
      if (modal.mode === "add") addQuestion(formQuestion);
      else updateQuestion(modal.data.id, formQuestion.intent_id, formQuestion.question);
    } else if (modal.type === "badword") {
      if (modal.mode === "add") addBadWord(formBadWord.word);
      else updateBadWord(modal.data.id, formBadWord.word);
    }
    setModal({ open: false, type: null, mode: null, data: null });
  };

  const toggleCategory = (id) => setExpandedCats((prev) => ({ ...prev, [id]: !prev[id] }));
  const toggleIntent = (id) => setExpandedIntents((prev) => ({ ...prev, [id]: !prev[id] }));

  // ========== RENDER TREE ==========
  const renderTree = () => (
    <div className="tree-container">
      <div className="tree-header"><h3>Hierarchical Training Panel</h3><button className="btn btn-success" onClick={openAddCategory}>+ New Category</button></div>
      {grouped.length === 0 && <p>Belum ada kategori. Silakan tambah.</p>}
      {grouped.map((group) => (
        <div key={group.category.id} className="tree-category">
          <div className="tree-cat-header" onClick={() => toggleCategory(group.category.id)}>
            <span className="toggle-icon">{expandedCats[group.category.id] ? "▼" : "▶"}</span>
            <span className="cat-name">Category: {group.category.name} ({group.intents.length} intent)</span>
            <div className="cat-actions" onClick={(e) => e.stopPropagation()}>
              <button className="btn-icon edit" onClick={() => openEditCategory(group.category)}> (edit) </button>
              <button className="btn-icon delete" onClick={() => deleteCategory(group.category.id)} disabled={group.category.question_count > 0}> (delete) </button>
              <button className="btn-icon add" onClick={() => openAddIntent(group.category.id)}>+ Intent</button>
            </div>
          </div>
          {expandedCats[group.category.id] && (
            <div className="tree-intents">
              {group.intents.map((intent) => (
                <div key={intent.id} className="tree-intent">
                  <div className="tree-intent-header" onClick={() => toggleIntent(intent.id)}>
                    <span className="toggle-icon">{expandedIntents[intent.id] ? "▼" : "▶"}</span>
                    <span className="intent-name">Intents: {intent.name} ({intent.questions.length} question)</span>
                    <div className="intent-actions" onClick={(e) => e.stopPropagation()}>
                      <button className="btn-icon edit" onClick={() => openEditIntent(intent)}> (edit) </button>
                      <button className="btn-icon delete" onClick={() => deleteIntent(intent.id)} disabled={intent.question_count > 0}> (delete) </button>
                      <button className="btn-icon add" onClick={() => openAddQuestion(intent.id)}>+ Question</button>
                    </div>
                  </div>
                  {expandedIntents[intent.id] && (
                    <div className="tree-intent-detail">
                      <div className="intent-response"><span className="response-label">Response:</span><span className="response-text">{intent.response || "(Belum ada response)"}</span></div>
                      <div className="tree-questions">
                        {intent.questions.map((q) => (
                          <div key={q.id} className="tree-question">
                            <span className="question-text">{q.question}</span>
                            <div className="question-actions">
                              <button className="btn-icon edit" onClick={() => openEditQuestion(q)}> (edit) </button>
                              <button className="btn-icon delete" onClick={() => deleteQuestion(q.id)}> (delete) </button>
                            </div>
                          </div>
                        ))}
                        {intent.questions.length === 0 && <div className="tree-question empty">(Tidak ada pertanyaan)</div>}
                      </div>
                    </div>
                  )}
                </div>
              ))}
              {group.intents.length === 0 && <div className="tree-intent empty">Belum ada intent. Klik "+ Intent"</div>}
            </div>
          )}
        </div>
      ))}
    </div>
  );

  const renderLogs = () => (
    <div className="card"><h3>Chat Logs</h3>
      <table className="table"><thead><tr><th>Question</th><th>Answer</th><th>Intent</th><th>Score</th><th>Status</th><th>Action</th></tr></thead>
      <tbody>{logs.map((l) => (
        <tr key={l.id}><td>{l.user_message}</td> <td>{l.bot_response}</td>
        <td><select value={l.matched_intent_id || ""} onChange={(e) => updateLogIntent(l.id, e.target.value)}><option value="">(none)</option>{intents.map((intent) => (<option key={intent.id} value={intent.id}>{intent.name}</option>))}</select></td>
        <td>{l.confidence_score ? Number(l.confidence_score).toFixed(2) : "-"}</td>
        <td>{l.is_correct === 1 ? "✅" : l.is_correct === 0 ? "❌" : "-"}</td>
        <td><button className="btn btn-success" onClick={() => validate(l.id, 1)}>✔</button><button className="btn btn-danger" onClick={() => validate(l.id, 0)}>✖</button><button className="btn btn-warning" onClick={() => addFromLog(l.id)} disabled={!l.matched_intent_id}>➕</button></td>
        </tr>))}</tbody>
      </table>
    </div>
  );

  const renderData = () => (
    <div className="card">
      <h3>Import / Export</h3>
      <button className="btn btn-success" onClick={exportExcel} disabled={importing}>Export Excel</button>
      <br /><br />
      <input type="file" accept=".xlsx" onChange={importExcel} disabled={importing} />
      {importing && <div className="progress-indicator">⏳ {importProgress}</div>}
    </div>
  );

  const renderBadWords = () => (
    <div className="card">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <h3>Daftar Kata Kotor</h3>
        <button className="btn btn-success" onClick={openAddBadWord}>+ Tambah Kata Kotor</button>
      </div>
      <table className="table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Kata Kotor</th>
            <th>Aksi</th>
          </tr>
        </thead>
        <tbody>
          {badWords.length === 0 ? (
            <tr><td colSpan="3" style={{ textAlign: 'center' }}>Belum ada data kata kotor.</td></tr>
          ) : (
            badWords.map((bw) => (
              <tr key={bw.id}>
                <td>{bw.id}</td>
                <td>{bw.word}</td>
                <td>
                  <button className="btn-icon edit" onClick={() => openEditBadWord(bw)}> ( Edit ) </button>
                  <button className="btn-icon delete" onClick={() => deleteBadWord(bw.id)}> ( Hapus ) </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );

  const renderModal = () => {
    if (!modal.open) return null;
    let title = "", content = null;
    if (modal.type === "category") {
      title = modal.mode === "add" ? "Tambah Kategori" : "Edit Kategori";
      content = (<><label>Nama Kategori</label><input type="text" value={formCat.name} onChange={(e) => setFormCat({ name: e.target.value })} placeholder="Contoh: Event" /></>);
    } else if (modal.type === "intent") {
      title = modal.mode === "add" ? "Tambah Intent" : "Edit Intent";
      content = (<><label>Kategori</label><select value={formIntent.category_id} onChange={(e) => setFormIntent({ ...formIntent, category_id: e.target.value })}><option value="">Pilih Kategori</option>{categories.map((c) => (<option key={c.id} value={c.id}>{c.name}</option>))}</select><label>Nama Intent</label><input type="text" value={formIntent.name} onChange={(e) => setFormIntent({ ...formIntent, name: e.target.value })} placeholder="Contoh: event_date" /><label>Response Bot</label><textarea value={formIntent.response} onChange={(e) => setFormIntent({ ...formIntent, response: e.target.value })} placeholder="Jawaban bot..." rows="3" /><label>Emotion</label><select value={formIntent.emotion} onChange={(e) => setFormIntent({ ...formIntent, emotion: e.target.value })}><option value="neutral">Neutral</option><option value="happy">Happy</option><option value="serious">Serious</option><option value="cheerful">Cheerful</option><option value="shy">Shy</option><option value="angry">Angry</option></select></>);
    } else if (modal.type === "question") {
      title = modal.mode === "add" ? "Tambah Pertanyaan" : "Edit Pertanyaan";
      content = (<><label>Intent</label><select value={formQuestion.intent_id} onChange={(e) => setFormQuestion({ ...formQuestion, intent_id: e.target.value })}><option value="">Pilih Intent</option>{intents.map((i) => (<option key={i.id} value={i.id}>{i.name}</option>))}</select><label>Pertanyaan</label><textarea value={formQuestion.question} onChange={(e) => setFormQuestion({ ...formQuestion, question: e.target.value })} placeholder="Contoh: Kapan jadwal mentoring?" rows="2" /></>);
    } else if (modal.type === "badword") {
      title = modal.mode === "add" ? "Tambah Kata Kotor" : "Edit Kata Kotor";
      content = (<><label>Kata Kotor</label><input type="text" value={formBadWord.word} onChange={(e) => setFormBadWord({ word: e.target.value })} placeholder="Contoh: bodoh" /></>);
    }
    return (<div className="modal-overlay" onClick={() => setModal({ open: false })}><div className="modal-content" onClick={(e) => e.stopPropagation()}><h3>{title}</h3><div className="modal-body">{content}</div><div className="modal-buttons"><button className="btn btn-secondary" onClick={() => setModal({ open: false })}>Batal</button><button className="btn btn-primary" onClick={handleModalSubmit}>Simpan</button></div></div></div>);
  };

  const goBack = () => {
    window.location.href = "/";
  };

  return (
    <div className="admin-container">
      <button className="adminButton" onClick={goBack} style={{ position: 'fixed', top: '12px', right: '12px', zIndex: 9999 }}>
        ← Kembali
      </button>
      
      <h1 className="admin-title">ADMIN CONTROL PANEL</h1>
      <div className="navbar">
        <button className={`nav-btn ${activeTab === "training" ? "active" : ""}`} onClick={() => setActiveTab("training")}>TRAINING</button>
        <button className={`nav-btn ${activeTab === "logs" ? "active" : ""}`} onClick={() => setActiveTab("logs")}>LOGS</button>
        <button className={`nav-btn ${activeTab === "data" ? "active" : ""}`} onClick={() => setActiveTab("data")}>DATA</button>
        <button className={`nav-btn ${activeTab === "badwords" ? "active" : ""}`} onClick={() => setActiveTab("badwords")}>BAD WORDS</button>
      </div>
      {activeTab === "training" && renderTree()}
      {activeTab === "logs" && renderLogs()}
      {activeTab === "data" && renderData()}
      {activeTab === "badwords" && renderBadWords()}
      {renderModal()}
    </div>
  );
}

export default Admin;